import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { CancelButton } from "../Buttons/CancelButton";
import { CloseButton } from "../Buttons/CloseButton";
import { ConfirmButton } from "../Buttons/ConfirmButton";
import { CopyButton } from "../Buttons/CopyButton";
import { InputTextComponent } from "../Inputs/InputTextComponent";
import { InputText } from "../Shared";
import { DialogResult, DialogStore, DialogType } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";

@observer
export class DialogBox extends React.Component<{}, {}> {

	handleYes = () => {
		DialogStore.open = false;
		DialogStore.resolve(DialogResult.Yes);
	}

	handleNo = () => {
		DialogStore.open = false;
		DialogStore.resolve(DialogResult.No);
	}

	handleCancel = () => {
		DialogStore.open = false;
		DialogStore.resolve(DialogResult.Cancel);
	}

	handleCopy = () => {
		let element = document.createElement('textarea');
		element.value = DialogStore.text;
		document.body.appendChild(element);
		element.select();
		document.execCommand('copy');
		document.body.removeChild(element);
	}

	get model() {
		let model = new InputText();
		model.isReadOnly = true;
		model.value = DialogStore.text;
		model.isValid = true;
		return model;
	}

	get content() {
		if (DialogStore.dialogType === DialogType.DeepLink) {
			return <div className="notebox-content deepLink">
				<div>{Strings.reader.yourGeneratedDeepLink}</div>
				<InputTextComponent model={this.model} testId="deepLink" />
				<CopyButton onClick={this.handleCopy} title={Strings.reader.copyDeepLinkButtonTitle} testId="dialogBoxCopyButton" />
				<div>{Strings.reader.deepLinkDescription}</div>
			</div>;
		}
		else if (DialogStore.dialogType === DialogType.Feedback) {
			return <div className="notebox-content">
				<label className="required">
					<span>
						{Strings.reader.subjectLabel}
					</span>
					<input type="text" ref="subject" value={DialogStore.subject} onChange={DialogStore.onSubjectChange} />
				</label>
				<label className="required">
					<span>
						{Strings.reader.messageLabel}
					</span>
					<textarea ref="message" value={DialogStore.message} onChange={DialogStore.onMessageChange}></textarea>
				</label>
			</div >;
		}
		else if (typeof DialogStore.text === "string") {
			return <div className="notebox-content" dangerouslySetInnerHTML={{ __html: DialogStore.text }} />;
		}
		else {
			return <div className="notebox-content">
				{DialogStore.text}
			</div>;
		}
	}

	@computed get isDisabled() {
		if (DialogStore.dialogType !== DialogType.Feedback) {
			return false;
		}
		let subject = DialogStore.subject;
		let message = DialogStore.message;
		return !subject || !message;
	}

	get toolbar() {
		if (DialogStore.dialogType !== DialogType.None) {
			if (DialogStore.dialogType === DialogType.DeepLink) {
				return null;
			}
			return <div className="notebox-toolbar">
				<ConfirmButton onClick={this.handleYes} disabled={this.isDisabled} testId="dialogBoxConfirmButton" />
				<span className="buttongroup is--buttongroup-right">
					<CancelButton onClick={this.handleNo} testId="dialogBoxCancelButton" />
				</span>
			</div>;
		}
		return null;
	}

	render() {
		if (DialogStore.open) {
			return <div className="dialogbox-wrapper is--dialog-open">
				<div className="notebox">
					<div className="notebox-head">
						<h2>{DialogStore.title}</h2>
						<span className="notebox-head__control">
							<div className="tinytool">
								<CloseButton onClick={this.handleCancel} testId="dialogBoxCloseButton" />
							</div>
						</span>
					</div>
					{this.content}
					{this.toolbar}
				</div>
			</div>;
		}
		else {
			return null;
		}
	}
}

